export const emailStyle = `
    .ql-size-small{
        font-size: 0.75em;
    }
    .ql-size-large{
        font-size: 1.5em;
    }
    .ql-size-huge {
        font-size: 2.5em;
    }
    .ql-align-center {
        text-align: center;
    }
    .ql-align-right {
        text-align: right;
    }
    .ql-align-justify {
        text-align: justify;
    }
`;
